export interface TransactionPayment {
    amount: number;
    type: PaymentTypes;
    lastDigits: string;
}

export enum PaymentTypes
{
    RewardCredits = 1,
    StoreCredits = 2,
    CreditCard = 3,
    FlexCredits = 4
}